import script from "./Filters.vue?vue&type=script&setup=true&lang=js"
export * from "./Filters.vue?vue&type=script&setup=true&lang=js"

import "./Filters.vue?vue&type=style&index=0&id=2c0ae5a8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c0ae5a8"]])

export default __exports__